module.exports = __webpack_public_path__ + "static/media/man-user.6a94861b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/man-user.svg
// module id = 1196
// module chunks = 0